import { isLinkType } from './helpers';
import { ColumnData, CellType, RowType, SortedColumnData } from './types';

export const sortColumnData = (columnData: ColumnData[]): SortedColumnData[] =>
  columnData
    .map((col, i) => ({ ...col, originalOrder: i }))
    .sort(
      (a, b) =>
        (a.settings?.small?.order ?? 0) - (b.settings?.small?.order ?? 0)
    );

export const getCellContent = (cell: CellType) =>
  isLinkType(cell) ? cell?.label ?? cell?.href : cell;

export const getCellHref = (cell: CellType) =>
  isLinkType(cell) ? cell?.href : undefined;

export const getCellOnClick = (cell: CellType) =>
  isLinkType(cell) ? cell?.onClick : undefined;

export const formatCells = (
  columnData: SortedColumnData[],
  row: RowType
): CellType[] => labelCells(columnData, sortCells(columnData, row));

const sortCells = (columnData: SortedColumnData[], row: RowType): CellType[] =>
  columnData.map((col) => row[col.key]);

const labelCells = (
  columnData: SortedColumnData[],
  row: CellType[]
): CellType[] => {
  return row.map((cell, i) => {
    const col = columnData[i];
    const label = col.settings?.small?.showLabel && col.label;

    if (label) {
      const formattedLabel = `${label}: ${
        isLinkType(cell) ? cell?.label : cell
      }`;
      return isLinkType(cell)
        ? { ...cell, label: formattedLabel }
        : formattedLabel;
    }

    return cell;
  });
};
